import { Component, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { UserFacade } from '@app/store/user';

@Component({
    selector: 'app-delete-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.css'],
    imports: [TranslateModule, ButtonModule],
})
export class DeleteButtonComponent {
    private readonly userFacade = inject(UserFacade);
    private readonly confirmationService = inject(ConfirmationService);
    private readonly translateService = inject(TranslateService);

    readonly userId = input.required<string>();
    readonly saving = input<boolean>(false);
    readonly testId = input.required<string>();

    onDelete(): void {
        this.confirmationService.confirm({
            header: this.translateService.instant('users.delete.header'),
            message: this.translateService.instant('users.delete.message'),
            icon: 'pi pi-exclamation-triangle',
            rejectButtonProps: {
                label: this.translateService.instant('users.delete.reject'),
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: this.translateService.instant('users.delete.accept'),
                severity: 'danger',
            },
            accept: () => {
                this.userFacade.deleteUser(this.userId());
            },
        });
    }
}
